// Function to clear all stored data
function clearStoredData() {
    localStorage.removeItem('productLimit');
    localStorage.removeItem('selectedProducts');
    localStorage.removeItem('counter');
    localStorage.removeItem('productLimits');
    console.log('Stored data cleared');
}

// Clear stored data when the page is loaded
document.addEventListener('DOMContentLoaded', function() {
    clearStoredData();

    const productLimits = []; // Initialize an empty array to store product limits

    // Iterate over each anchor (a) to calculate the product limits and store them in the array
    document.querySelectorAll('.limit-button').forEach((anchor) => {
        const idValue = parseInt(anchor.id, 10); // Extract the ID and convert to a number
        const productLimit = idValue / 54321; // Calculate the product limit
        
        // Add the calculated product limit to the array
        productLimits.push(productLimit);
    });

    // Store all the calculated product limits in localStorage
    localStorage.setItem('productLimits', JSON.stringify(productLimits));

    // Handle anchor (a) clicks to store the selected product limit and navigate to the product grid
    document.querySelectorAll('.limit-button').forEach((anchor) => {
        anchor.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default anchor navigation behavior

            // Extract the ID and calculate the product limit for the clicked anchor
            const idValue = parseInt(anchor.id, 10);
            const selectedLimit = idValue / 54321;

            // Store the selected product limit in localStorage
            localStorage.setItem('productLimit', selectedLimit);

            // Detect language from the <html> tag
            const lang = document.documentElement.lang;

            // Build the correct URL
            const baseUrl = 'https://www.alegraboxes.es';
            const collectionPath = '/collections/alegra-custom-box';

            // Final URL according to language
            const targetUrl = lang === 'en'
            ? `${baseUrl}/en${collectionPath}`
            : `${baseUrl}${collectionPath}`;

            // Navigate
            window.location.href = targetUrl;


        });
    });
});
